// Module
var code = "<exiting-app></exiting-app>";
// Exports
module.exports = code;